import React from "react";
import { fetchData } from "../utility/fetcher";

// cache will contain { domainName: 'domain.com', domainType: 'A' , data: [] }
let domainCache = {};

const initState = {
	loading: false,
	data: null,
	error: null,
};

const reducer = (state, action) => {
	switch (action.type) {
		case "FETCHING":
			return { ...state, loading: true, data: null };
		case "FETCHED":
			return { ...state, loading: false, data: action.payload, error: null };
		case "FETCH_ERROR":
			return { ...initState, error: action.payload };
		default:
			return state;
	}
};

const useDnsFetch = (inputIsValid, domainInput, domainType) => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const URL = "/api/dns-lookup";

	React.useEffect(() => {
		if (!inputIsValid || !domainType) return;

		// if domainInput and domainType is the same as in domainCache object -> set the state to the cached result
		if (
			domainCache.domainName === domainInput &&
			domainCache.domainType === domainType
		) {
			return dispatch({ type: "FETCHED", payload: domainCache.data });
		}

		const fetchDomainData = async () => {
			let searchQuery = domainInput.trim();

			// Remove "http://" or "https://" from search string
			if (
				searchQuery.indexOf("http://") >= 0 ||
				searchQuery.indexOf("https://") >= 0
			) {
				searchQuery = searchQuery
					.replace("https://", "")
					.replace("http://", "");
			}

			// remove any trailing slashes
			searchQuery = searchQuery.replace(/\/+$/, "");

			const body = { domain: searchQuery, domainType: domainType };

			try {
				const result = await fetchData(URL, body);
				if (result.status === "OK") {
					dispatch({ type: "FETCHED", payload: result.data });

					// set the domainCache object to the newly fetched data
					domainCache = {
						domainName: domainInput,
						domainType,
						data: result.data,
					};
				}
				if (result.status === "error") {
					dispatch({ type: "FETCH_ERROR", payload: result.message });
				}
			} catch (err) {
				console.warn(err);
			}
		};

		dispatch({ type: "FETCHING" });
		const timer = setTimeout(() => {
			fetchDomainData();
		}, 800);

		return () => {
			clearTimeout(timer);
		};
	}, [domainInput, inputIsValid, domainType]);

	return { dnsData: state };
};

export default useDnsFetch;
